import React, {Component} from 'react'
import logo from '../assets/mobn-logo.jpg'

class FormIntro extends Component{
    render(){
        return(
            
            <div className="grid">
                
                <img src={logo} style={{alignSelf:'flex-start'}}/>
            
                <h1 className = "title">Register your <br/>movie blog here</h1>
                
                <h5>Your ticket to the Movie Bloggers Network</h5>
                
                <p>The Movie Bloggers Network is an eclectic international film community of movie bloggers, film critics and cinephiles! You’ll also find movie writers, filmmakers, actors, folks from the movie industry plus cinema aficionados and movie fans from across the world in our midst. We are truly an assorted bunch but united in our absolute love for the moving pictures!</p>
                
                <p>Join our Network! Register your Movie Blog NOW!</p>
            
                <p>Please fill-in the form below to register your movie blog or film site at the Movie Bloggers Network. When our website (currently under development) is ready, we will contact you again to formally complete your blog registration and give you access to what we are building on the site. Please try to answer all questions below. The more info you share, the better for us to know you better and gear the site better to your needs! Besides, we aim to showcase all Movie Bloggers every week so please answer the Q and A section too!

            </p>
            </div>
            
        
            
            
        )
    }
}

export default FormIntro;